import { ConfigurationRepositoryTypesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryTypesService'
import type { Except } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

type InputArguments = Except<
  Parameters<
    typeof ConfigurationRepositoryTypesService.typesServicePostPostTypesVersion
  >[0],
  'xProcessType' | 'xProcessId'
>

export const useCreateTypesVersion = () =>
  useMutation({
    mutationFn: async ({ requestBody }: InputArguments) =>
      await ConfigurationRepositoryTypesService.typesServicePostPostTypesVersion(
        {
          requestBody,
        },
      ),
  })
